/**
 * TODO: BACKEND API CONTRACT REQUIRED
 *
 * Operations the admin UI is built for but the backend contract does not define yet. Adapters
 * call `contractRequired(name)` for these instead of guessing an endpoint. The list mirrors
 * `x-pending-operations` in admin-api.openapi.yaml (enforced by tests/contract.test.ts) and is
 * shown to admins under Settings → API contract.
 */
export const PENDING_OPERATIONS = {} as const satisfies Record<string, string>;

export type PendingOperation = keyof typeof PENDING_OPERATIONS;
